import log from '../utils/log' // eslint-disable-line
import textfit from 'textfit'

export class StaffValet {
  init () {
    // Only select visible components - e.g. not things in closed modals
    $('.textfit:visible').each(function (index) {
      const $this = $(this)
      $this.css('width', `${$this.outerWidth()}px`)
      textfit($this)
    })
  }
}
